export const getNotionFileValue = (
  val: any[] | undefined,
  valueWhenMissing: string
) => {
  return val?.[0]?.[1]?.[0]?.[1] || valueWhenMissing
}
